'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');
const Translator = require('./../../../../core/translator');

let ElementClass = require('./../../elementClass');

let tpl = require('./template/index.hbs');

FormBuilder.register('height', function(config) {
    let self = {};
    let value = config.value || config.default_value || 0;
    let onChange = config.onChange || jQuery.noop;

    self = new ElementClass(config);

    self.render = function($wrap) {
        $wrap.append(tpl());

        let $label = $wrap.find('.cloud-label');
        if (config.label) {
            $label.text(Translator.translate(config.label));
        }

        $wrap.find('.btn').on('mousedown', function(event) {
            const callback = function(event) {
                let $button = jQuery(event.currentTarget);
                let step = 2;

                if ($button.hasClass('less')) {
                    if ((value - step) >= 0) {
                        value = value - step;
                        $wrap.find('.value').val(value + 'px');
                        onChange(-step);
                    } else {
                        onChange(0);
                    }
                } else {
                    value = value + step;
                    $wrap.find('.value').val(value + 'px');
                    onChange(step);
                }
            };

            callback(event);

            jQuery(event.currentTarget).on('mouseup', function() {
                clearInterval(interval);
                jQuery(window).off('mouseup.height-param');
            });

            let interval = setInterval(callback.bind(undefined, event), 100);

            jQuery(window).on('mouseup.height-param', function() {
                clearInterval(interval);
                jQuery(window).off('mouseup.height-param');
            });
        });

        $wrap.find('.value').on('change keyup paste', function() {
            value = parseInt(jQuery(this).val(), 10);
        }).val(value + 'px');
    };

    self.getData = function() {
        return value;
    };

    return self;
});
